{
  "scheduled_for_deletion_alert_bar": {
    "message": "We've detected that this team has no active store connected and we've scheduled this for removal as part of our clean up processes."
  },
  "restricted_session_alert_bar": {
    "logged_in_via": "Logged in via {platformName}",
    "message": "If you need to modify teams or account details, sign in with your SparkLayer account instead.",
    "log_out": "Log out"
  }
}
